import axios from 'axios';
import { ValidationError } from '../types/api-response.types';

export const extractCreateError = (error: any, defaultErrorMessage: string): string => {
  let errorMessageString = defaultErrorMessage;

  if (error?.response?.data?.type === 'ValidationError') {
    const validationErrors = error.response.data.data.validationErrors;
    errorMessageString = 'Please fix the validation errors';
  } else if (error?.response?.data?.type === 'DuplicateKeyError') {
    const field = error.response.data.data.field;
    const errorMessage = error.response.data.data.message;
    errorMessageString = `${errorMessage} (Field: ${field})`;
  }

  if (axios.isAxiosError(error)) {
    // If it's an Axios error, try to get the error message from the response
    const responseError = error.response?.data?.data?.message || error.response?.data?.message;
    if (responseError) {
      errorMessageString =
        typeof responseError === 'string' ? responseError : JSON.stringify(responseError);
    }
  }

  return errorMessageString;
};

export const extractValidationError = (error: any): ValidationError[] => {
  let allValidationErrors: ValidationError[] = [];
  if (error?.response?.data?.type === 'ValidationError') {
    const validationErrors = error.response.data.data.validationErrors;
    allValidationErrors = validationErrors;
  } else if (error?.response?.data?.type === 'DuplicateKeyError') {
    const field = error.response.data.data.field;
    const errorMessage = error.response.data.data.message;
    allValidationErrors = [{ path: field, message: errorMessage }];
  }

  return allValidationErrors;
};
